import { AbstractControl } from "@angular/forms";
import { isValid, parse } from 'date-fns';

export function poRequiredValidator(c: AbstractControl): {[key:string]:boolean} | null{
  let projectStatus =  c.get("projectStatus");
  let poNumber = c.get("poNumber");
  let poAmount = c.get("poAmount");

  // Project status is in the format of {id:number, name:string}
  if (projectStatus.value && projectStatus.value.name === "PO Received"){
    if (!poNumber.value){
      poNumber.setErrors({"required": true});
      return {"poNumberRequired": true};
    }

    if (!poAmount.value){
      poAmount.setErrors({"required": true});
      return {"poAmountRequired": true};
    }
  }
  return null;
}
